import * as React from "react";
import { Async, Option, Options } from "react-select";
import apifetch from "utils/apifetch";
import extractErrorMessage from "utils/extractErrorMessage";

interface Props {
    value?: Option;
    onItemSelect?: (value: Option | null) => void;
    includeInternal?: boolean;
}

interface State {
    value?: Option;
}

export default class JobSelect extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            value: props.value,
        };

        this.getJobs = this.getJobs.bind(this);
        this.filterJobs = this.filterJobs.bind(this);
        this.handleValueChanged = this.handleValueChanged.bind(this);
    }

    public render() {
        return (
            <div>
                <Async
                    value={this.state.value}
                    onChange={this.handleValueChanged}
                    placeholder=""
                    isLoading={true}
                    loadOptions={this.getJobs}
                    filterOptions={this.filterJobs}
                />
            </div>
        );
    }

    public getJob() {
        if (this.state.value === undefined || this.state.value === null) {
            return null;
        }

        return {
            id: this.state.value!.value as number,
            name: this.state.value!.label as string,
        };
    }

    public get value() {
        return this.state.value as Option | undefined;
    }

    public set value(value: Option | undefined) {
        this.setState({
            value: value,
        });
    }

    private handleValueChanged(newValue: Option | null) {
        this.setState({
            value: newValue as Option,
        });

        if (this.props.onItemSelect !== undefined) {
            this.props.onItemSelect!(newValue);
        }
    }

    private async getJobs(input: string) {
        if (!input) {
            return {
                options: [],
            };
        }

        const endpoint = this.props.includeInternal
            ? `jobs/searchall?query=${encodeURIComponent(input)}`
            : `jobs/search?query=${encodeURIComponent(input)}`;
        let response = await apifetch(
            endpoint,
            undefined,
            true
        );
        if (response.ok) {
            let data = await response.json();
            return {
                options: data.map((x: { id: number; name: string }) => ({
                    value: x.id,
                    label: x.name,
                })),
            };
        } else {
            console.error(await extractErrorMessage(response));
        }
    }

    private filterJobs(options: Options, filter: string, currentValues: Options) {
        return options;
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/common/JobSelect.tsx